(ns nosco.shared.layouts
  (:require [nosco.colors]))

(defn page-with-header [{:keys [header children support-btn]}]
  [:div {:class "nosco-layout-page-with-header"}
   [:div {:class "nosco-layout-page-with-header__header"}
    header]
   children
   (when support-btn
     [:div {:class "nosco-layout-page-with-header__support"}
      support-btn])])

(defn header-bar [{:keys [color logo buttons hb-button right-buttons]}]
  [:div {:class (str "nosco-topnav")
         :id "nosco-topnav-header"
         :style {:background-color color}}
   [:div {:class "nosco-topnav__internal"}
    hb-button
    logo
    [:div {:class "nosco-topnav__buttons"}
     buttons]
    right-buttons]])

(defn loading-icon [{:keys [size color class]
                     :or {size :small}}]
  (let [circles {:small {:cx 8 :cy 8 :r 6 :stroke color :stroke-width 1.85 :fill "transparent"}
                 :large {:cx 12 :cy 12 :r 8 :stroke color :stroke-width 2 :fill "transparent"}
                 :x-large {:cx 24 :cy 24 :r 14 :stroke color :stroke-width 4 :fill "transparent"}}]
    [:svg (-> {:class ["nosco-icon" class]
               :aria-label "Loading"
               :style (cond-> {}
                        (= size :x-large) (merge {:width "48px" :height "48px"})
                        (= size :large) (merge {:width "24px" :height "24px"})
                        (= size :small) (merge {:width "16px" :height "16px"}))})
     [:circle (assoc (get circles size) :stroke-dasharray "47% 1000")]
     [:circle (assoc (get circles size) :opacity "0.4")]]))

(defn fullscreen-loading-spinner [{:keys [loading-text]}]
  [:div {:class "fullscreen-loading-spinner"}
   (loading-icon {:size :x-large :color nosco.colors/neutral-400
                  :class "nosco-animation-loading-rotate-360"})
   [:div {:class "fullscreen-loading-spinner__text"}
    loading-text]])

(defn error-icon [{:keys [color class size]}]
  [:svg (-> {:class ["nosco-icon" class]
             :aria-label "Loading"
             :style (cond-> {}
                      (= size :x-large) (merge {:width "48px" :height "48px" :fill "yellow"})
                      (= size :large) (merge {:width "24px" :height "24px"})
                      (= size :small) (merge {:width "16px" :height "16px"}))})
   [:g {:transform (let [scale (case size
                                 :x-large 2
                                 :large 1
                                 :small 0.66666)]
                     (str "scale(" scale ")"))}
    [:path {:fill color
            :d "M19.8001 16.526L13.4831 4.88C13.3273 4.59107 13.0897 4.35452 12.8001 4.2C12.4066 3.98943 11.9459 3.94274 11.5182 4.07008C11.0905 4.19743 10.7303 4.4885 10.5161 4.88L4.2001 16.526C4.06199 16.7823 3.99294 17.0701 3.99972 17.3611C4.00651 17.6522 4.0889 17.9365 4.23881 18.186C4.38871 18.4356 4.60096 18.6419 4.85471 18.7846C5.10846 18.9273 5.39497 19.0015 5.6861 19H18.3141C18.5931 19 18.8679 18.9313 19.1141 18.8C19.3092 18.6965 19.4818 18.5553 19.622 18.3847C19.7623 18.2142 19.8674 18.0175 19.9312 17.8061C19.9951 17.5947 20.0165 17.3727 19.9942 17.153C19.9718 16.9333 19.9062 16.7202 19.8011 16.526H19.8001ZM12.0001 17C11.8023 17 11.609 16.9414 11.4445 16.8315C11.2801 16.7216 11.1519 16.5654 11.0762 16.3827C11.0005 16.2 10.9807 15.9989 11.0193 15.8049C11.0579 15.6109 11.1531 15.4327 11.293 15.2929C11.4328 15.153 11.611 15.0578 11.805 15.0192C11.999 14.9806 12.2001 15.0004 12.3828 15.0761C12.5655 15.1518 12.7217 15.28 12.8316 15.4444C12.9414 15.6089 13.0001 15.8022 13.0001 16C13.0001 16.2652 12.8947 16.5196 12.7072 16.7071C12.5197 16.8946 12.2653 17 12.0001 17V17ZM13.0001 13.5C13.0001 13.6326 12.9474 13.7598 12.8537 13.8536C12.7599 13.9473 12.6327 14 12.5001 14H11.5001C11.3675 14 11.2403 13.9473 11.1465 13.8536C11.0528 13.7598 11.0001 13.6326 11.0001 13.5V9.5C11.0001 9.36739 11.0528 9.24022 11.1465 9.14645C11.2403 9.05268 11.3675 9 11.5001 9H12.5001C12.6327 9 12.7599 9.05268 12.8537 9.14645C12.9474 9.24022 13.0001 9.36739 13.0001 9.5V13.5Z"}]]])

(defn fullscreen-loading-error [{:keys [error-text]}]
  [:div {:class "fullscreen-loading-spinner"}
   (error-icon {:size :x-large :color nosco.colors/error-500})
   [:div {:class "fullscreen-loading-spinner__text"}
    error-text]])

(defn header-logo [{:keys [img-src href]}]
  [:a {:class "nosco-topnav__logo"
       :href href}
   [:img {:src img-src}]])
